import React from 'react';
import { SectionDiv } from '../component/section/SectionDiv';
import { GeneralPageLayout } from '../layout/GeneralPageLayout';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';

export const SectionPage = () => (
  <GeneralPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<SectionDiv />}
  />
);
